import { useNavigate } from 'react-router'
import { CardImage } from '#app/components/ui/card-image.tsx'
import { Tag } from '#app/components/ui/tag.tsx'

export default function ProgramsSection() {
	const navigate = useNavigate()
	return (
		<section className="mx-auto max-w-[1200px] px-[37.5px] pt-[64px] pb-[48px] md:px-0 md:pt-[48px] md:pb-[72px]">
			<div className="mb-[56px]">
				<Tag
					size="l"
					corner="rounded"
					variant="secondary"
					color="green"
					appearance="solid"
					leftIcon="rocket-01"
					option="text-icon-left"
				>
					Proyectos
				</Tag>
			</div>
			<h3 className="mb-10 text-[32px] leading-[45px] font-medium text-blue-800 md:mb-6 md:text-[48px] md:leading-[64px]">
				Sostenibilidad es acción diaria
			</h3>
			<div className="grid gap-6 md:grid-cols-2 md:gap-[12px]">
				<CardImage
					backgroundImage="/img/programa-madre-card.avif"
					title="Educa ConCiencia"
					showButton={false}
					iconButtonIcon="arrow-up-right-01-round"
					className="h-[365px] w-full md:w-[594px]"
					onIconButtonClick={() => navigate('/programa-madre')}
				/>
				<CardImage
					backgroundImage="/img/fondo-agua-card.avif"
					title="Fondo de Agua del Río Mendoza"
					showButton={false}
					iconButtonIcon="arrow-up-right-01-round"
					className="h-[365px] w-full md:w-[594px]"
					onIconButtonClick={() => navigate('/fondo-de-agua')}
				/>
			</div>
		</section>
	)
}
